import {errorActions} from "../ErrorHandler/errorHandler";
import api from "../../util/api";
import {getContext} from "../../redux_slices/contextSlice";

export const actionTypes = {
    setToken: "setToken",
    expiryDate: "expiryDate",
    logout: "logout",
    setIsLoading: "setIsLoading",
    getSessionInfo: "getSessionInfo",
    updateAccount: "updateAccount",
    updateProfile: "updateProfile",
    setIsFirstLogin: "setIsFirstLogin",
    setTermsAndConditionsAccepted: "setTermsAndConditionsAccepted",
};

const initialAuthState = {
    account: {
        id: null,
        name: "",
        surname: "",
        username: "",
        avatar_url: "",
        created_at: "",
        updated_at: "",
        deleted_at: "",
        parameters: [
            {
                created_at: "",
                created_by: null,
                credential_id: null,
                id: null,
                type: {id: 4, name: "language"},
                type_id: 4,
                updated_at: null,
                updated_by: null,
                value: null,
            },
        ],
    },
    settings: [],
    permissions: undefined,
    current_company: null,
    profile: {},
    isAdmin: false,
    token: undefined,
    expiryDate: undefined,
    isLoading: false,
    termsAndConditions: true,
};

export const reducer = (state = initialAuthState, action) => {
    switch (action.type) {
        case actionTypes.setToken: {
            const {token, termsAndConditions} = action.payload;
            return {...state, token, termsAndConditions};
        }
        case actionTypes.expiryDate: {
            const {expiryDate} = action.payload;
            return {...state, expiryDate};
        }

        case actionTypes.setTermsAndConditionsAccepted: {
            const {termsAndConditions} = action.payload;
            return {...state, termsAndConditions};
        }

        case actionTypes.logout: {
            return initialAuthState;
        }

        case actionTypes.getSessionInfo: {
            const {account, settings, permissions, current_company, isAdmin, profile} = action.payload;
            return {
                ...state,
                account,
                settings,
                permissions,
                current_company,
                isAdmin,
                profile,
            };
        }

        // case actionTypes.updateAccount: {
        // const { account } = action.payload;
        // return { ...state, account };
        // }

        case actionTypes.updateProfile: {
            const {profile} = action.payload;

            return {...state, profile};
        }

        case actionTypes.setIsLoading: {
            const {isLoading} = action.payload;

            return {...state, isLoading};
        }

        default:
            return state;
    }
};

export const authActions = {
    updateAccount: ({language}) => dispatch => {
        //-----by now, we only use this action to edit Language, and "editProfile" for the rest!!-----

        return api
            .put(
                `v2/api/profile/parameters`,
                {parameters: {language}},
                {
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                    },
                }
            )
            .then(res => {
                const {
                    data: {result = ""},
                } = res;

                if (result === "success") {
                    dispatch(getContext());
                } else {
                    dispatch(errorActions.setErrorMessage("Something went wrong..."));
                }
            })
            .catch(err => {
                dispatch(errorActions.setErrorMessage(err.message));
            });
    },
    //end account actions

    //start language:

    //end language
};
